import type { Locale } from '../../../../types';
import type { ResourcesSource } from '../types';

/**
 * Validates locale parameter
 */
export const validateLocale = (locale: Locale): void => {
    if (!locale || typeof locale !== 'string') {
        throw new Error('Parameter "locale" must be a non-empty string.');
    }

    if (!locale.trim()) {
        throw new Error('Parameter "locale" must not be empty or whitespace-only.');
    }
};

/**
 * Validates resources source parameter
 */
export const validateResourcesSource = (resourcesSource: ResourcesSource): void => {
    if (!resourcesSource || typeof resourcesSource !== 'object') {
        throw new Error('Parameter "resourcesSource" must be a valid object.');
    }
};

/**
 * Validates translation key parameter
 */
export const validateTranslationKey = (key: string): void => {
    if (!key) {
        throw new Error('Parameter "key" must not be empty.');
    }

    if (typeof key !== 'string') {
        throw new Error('Parameter "key" must be a string.');
    }

    if (!key.includes('.')) {
        throw new Error('Parameter "key" must contain at least one dot separator (e.g., "namespace.key").');
    }
};
